// import axios from 'axios'

const state = {
    is_login: false,
    cont_id: "",
    site_no: "",
    is_relogin: false,
    live_access_token: "",
    role_id: "",
    auth_type_id: "",
}

const getters = {
    getIsRequiredAuth(state) {
        return state.is_login
    },
    getSiteNo(state) {
        return state.site_no
    },
    getIsRelogin(state) {
        return state.is_relogin
    },
    getLiveAccessToken(state) {
        return state.live_access_token
    },
    getRoleId(state) {
        return state.role_id
    },
    getAuthTypeId(state) {
        return state.auth_type_id
    },
}

const mutations = {
    setIsRequiredAuth(state, is_login) {
        state.is_login = is_login
    },
    setSiteNo(state, site_no) {
        state.site_no = site_no
    },
    setIsRelogin(state, is_relogin) {
        state.is_login = is_relogin
    },
    setLiveAccessToken(state, live_access_token) {
        state.live_access_token = live_access_token
    },
    setRoleId(state, role_id) {
        state.role_id = role_id;
    },
    setAuthTypeId(state, auth_type_id) {
        state.auth_type_id = auth_type_id;
    },
}

// const actions = {

// }

const auth = {
    namespaced: true,
    state,
    getters,
    mutations,
    // actions
}

export default auth